module.exports = __webpack_public_path__ + "static/media/pin-red.38aa35be.svg";